import { memoize } from 'lodash';
import { hosts } from 'settings';

export const assetSrc = memoize(path => {
  if (path && !/https?:\/\//.test(path)) {
    return `${hosts.api}${path}`;
  }

  return path;
});



// WEBPACK FOOTER //
// ./src/utils/assetSrc.js